module.exports = __webpack_public_path__ + "static/sacrificial-fragments-714305876d14594ae6ac234b9ca49c66.png";